export interface GeneralLayout {
  id: number;
  nomeLayout: string;
}
